import { createContext } from 'react';

const initialValue = {
  setHidden: state => {
    console.warn('Trying to set to ', state);
  }
}; // eslint-disable-next-line import/prefer-default-export

const HideContext = /*#__PURE__*/createContext(initialValue);

export { HideContext };
//# sourceMappingURL=useHiding.js.map
